import { Form, Input, InputNumber, Space } from "antd";
import WrappingModal from "../../../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  loading: boolean;
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  loading,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل ضريبة" : "إضافة ضريبة"}
    >
      <Form form={form} layout="vertical" onFinish={handleOk}>
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {isEditing && (
              <Form.Item name="TaxID" label="كود الضريبة">
                <InputNumber
                  placeholder="كود الضريبة"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}

            <Form.Item
              name="TaxName"
              label="اسم الضريبة"
              rules={[{ required: true, message: "من فضلك أدخل اسم الضريبة" }]}
            >
              <Input placeholder="القيمة المضافة، جدول..." />
            </Form.Item>

            <Form.Item
              name="TaxRate"
              label="نسبة الضريبة"
              rules={[{ required: true, message: "من فضلك أدخل النسبة" }]}
            >
              <InputNumber
                placeholder="مثال: 14"
                className="w-full"
                min={0}
                max={100}
              />
            </Form.Item>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
